// removed by extract-text-webpack-plugin
module.exports = {"authorizationExpired":"AuthorizationExpired__authorizationExpired","title":"AuthorizationExpired__title","providerLogo":"AuthorizationExpired__providerLogo","message":"AuthorizationExpired__message","button":"AuthorizationExpired__button","logout":"AuthorizationExpired__logout","email":"AuthorizationExpired__email","growDotQello":"AuthorizationExpired__growDotQello","growDotBlue":"AuthorizationExpired__growDotBlue","growDotGolden":"AuthorizationExpired__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/AuthorizationExpired/AuthorizationExpired.scss
// module id = 1893
// module chunks = 0